import React from "react";

const PositioningSection = () => {
  return (
    <div className="bg-[#F7FAFB] py-12 md:py-16">
      <div className="max-w-8xl mx-auto px-7 md:px-10 text-center">
        {/* Content */}
        <p className="md:mt-6 mt-4 text-[#6D7380] text-lg md:text-xl leading-relaxed max-w-2xl mx-auto">
          Most teams evaluate custody providers based on features and surface-level security claims.
          We go further and analyze how each system behaves internally, so you can see the difference
          between a platform that looks secure and one that actually is.
        </p>

      </div>
    </div>
  );
};

export default PositioningSection;